/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomProductStatusDto } from '../models/pom-product-status-dto';


/**
 * the ProductTemporary API
 */
@Injectable({
  providedIn: 'root',
})
export class ProductTemporaryService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation productUpdateStatus
   */
  static readonly ProductUpdateStatusPath = '/product/{id}/status';

  /**
   * Update status, temporary service
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productUpdateStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productUpdateStatus$Response(params: {

    /**
     * Id of the product
     */
    id: number;
    body: PomProductStatusDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProductTemporaryService.ProductUpdateStatusPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Update status, temporary service
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productUpdateStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productUpdateStatus(params: {

    /**
     * Id of the product
     */
    id: number;
    body: PomProductStatusDto
  },
  context?: HttpContext

): Observable<void> {

    return this.productUpdateStatus$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
